var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('side-bar'),_c('div',{staticClass:"content"},[_c('user-header-mobile'),_c('user-header-desktop'),_c('div',{staticClass:"slot-content"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }